import i18next from 'i18next';

/**
 * Retrieves the localized entity name based on the provided endpoint name.
 *
 * This function checks the `endpointName` string for specific keywords and returns
 * a corresponding localized entity name using the `i18next.t` translation function.
 * If no matching keyword is found, it defaults to returning the localized name for "item".
 *
 * @param endpointName - The name of the endpoint to determine the entity name for.
 * @returns The localized entity name corresponding to the endpoint.
 *
 * @example
 * ```typescript
 * const entityName = getEntityName('UserProfile');
 * // entityName will contain the localized string for 'entities.user'
 * ```
 */
export const getEntityName = (endpointName: string) => {
  if (endpointName.includes('ContentContext'))
    return i18next.t('entities.contentContext');
  if (endpointName.includes('Content')) return i18next.t('entities.content');
  if (endpointName.includes('Role')) return i18next.t('entities.role');
  if (endpointName.includes('User')) return i18next.t('entities.user');
  if (endpointName.includes('Media')) return i18next.t('entities.media');
  if (endpointName.includes('Questionnaire'))
    return i18next.t('entities.questionnaire');
  if (endpointName.includes('Question')) return i18next.t('entities.question');
  if (endpointName.includes('Answer')) return i18next.t('entities.answer');
  if (endpointName.includes('Notification'))
    return i18next.t('entities.notification');
  if (endpointName.includes('Version')) return i18next.t('entities.version');
  if (endpointName.includes('Broadcast'))
    return i18next.t('entities.broadcast');
  if (endpointName.includes('Session')) return i18next.t('entities.session');
  return i18next.t('entities.item');
};
